import type { FetchKiyOhReviewsParams } from './connector';

export const kiyOhKeys = {
  kiyOhReviews: (params: FetchKiyOhReviewsParams) => ['kiyOhReviews', params],
};
